import {Switch} from 'components/common/Switch.component';
import type {Translate} from 'types/myTasks';

interface BetaSwitchProps {
    isChecked: boolean;
    onChange: () => void;
    translate: Translate;
}

/**
 * Switch between the new My tasks and the old flat list, shown at the bottom left of the list, in its footer row.
 */
const BetaSwitch = ({isChecked, onChange, translate}: BetaSwitchProps) => (
    <div className="my-tasks-beta-switch" data-cy="myTasks.betaSwitch">
        <Switch
            label={translate('myTasks.overview.beta')}
            isChecked={isChecked}
            isDisabled={false}
            onChange={onChange}
        />
    </div>
);

export default BetaSwitch;
